import { useEffect, useSyncExternalStore } from 'react';

const KEY = 'hue.collection-view';
const EVENT = 'hue:collection-view';
type CollectionView = 'list' | 'cards';
function snapshot(): CollectionView {
  return localStorage.getItem(KEY) === 'cards' ? 'cards' : 'list';
}
function subscribe(listener: () => void) {
  window.addEventListener(EVENT, listener);
  window.addEventListener('storage', listener);
  return () => {
    window.removeEventListener(EVENT, listener);
    window.removeEventListener('storage', listener);
  };
}
export function useCollectionView() {
  const view = useSyncExternalStore(subscribe, snapshot, () => 'list' as const);
  useEffect(() => {
    document.documentElement.dataset.collectionView = view;
  }, [view]);
  return view;
}
